// https://github.com/onderonur/react-intersection-observer-hook/blob/master/src/useMonitorVisibility.ts

import { useEffect, useState } from 'react';

import useIntersectionObserver, {
  IntersectionObserverHookArgs,
  IntersectionObserverHookResult,
} from './use-intersection-observer';

export type MonitorVisibilityHookArgs = IntersectionObserverHookArgs & {
  triggerOnce?: () => void;
};

export type MonitorVisibilityHookResult = [
  IntersectionObserverHookResult[0],
  IntersectionObserverHookResult[1] & {
    isVisible: boolean;
    wasEverVisible: boolean;
  },
];

function useMonitorVisibility(
  args?: MonitorVisibilityHookArgs
): MonitorVisibilityHookResult {
  const [ref, result] = useIntersectionObserver(args);
  const isVisible = Boolean(result.entry?.isIntersecting);
  const [wasEverVisible, setWasEverVisible] = useState(isVisible);
  const [triggerOnce, setTriggerOnce] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setWasEverVisible(true);
      if (!triggerOnce && args?.triggerOnce) {
        setTriggerOnce(true);
        args.triggerOnce();
      }
    }
  }, [isVisible, args, triggerOnce]);

  return [ref, { ...result, isVisible, wasEverVisible }];
}

export default useMonitorVisibility;
